import { render, staticRenderFns } from "./Criar-Comunicado.vue?vue&type=template&id=5a9e4ff1&scoped=true&"
import script from "./Criar-Comunicado.vue?vue&type=script&lang=js&"
export * from "./Criar-Comunicado.vue?vue&type=script&lang=js&"
import style0 from "./Criar-Comunicado.vue?vue&type=style&index=0&id=5a9e4ff1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e4ff1",
  null
  
)

component.options.__file = "Criar-Comunicado.vue"
export default component.exports